<template>
  <div class="organization-selector">
    <label>
      <input
        type="checkbox"
        value="algemeen"
        @click.prevent="toggleOrganization"
        :checked="hasOrganization('algemeen')"
      > {{this.companyNameHelperFunction('algemeen')}}
    </label>
    <label>
      <input
        type="checkbox"
        value="zorg"
        @click.prevent="toggleOrganization"
        :checked="hasOrganization('zorg')"
      > {{this.companyNameHelperFunction('zorg')}}
    </label>
    <label>
      <input
        type="checkbox"
        value="maak"
        @click.prevent="toggleOrganization"
        :checked="hasOrganization('maak')"
      > {{this.companyNameHelperFunction('maak')}}
    </label>
    <label>
      <input
        type="checkbox"
        value="retail"
        @click.prevent="toggleOrganization"
        :checked="hasOrganization('retail')"
      > {{this.companyNameHelperFunction('retail')}}
    </label>
    <label>
      <input
        type="checkbox"
        value="consultancy"
        @click.prevent="toggleOrganization"
        :checked="hasOrganization('consultancy')"
      > {{this.companyNameHelperFunction('consultancy')}}
    </label>
    <label>
      <input
        type="checkbox"
        value="other"
        @click.prevent="toggleOrganization"
        :checked="hasOrganization('other')"
      >
      {{this.companyNameHelperFunction('other')}}
    </label>
    <!-- <select :id="uniqueId" multiple v-model="organizations" @change="checkOrganizations">
            <option value="algemeen" :selected="hasOrganization('algemeen')">Algemeen</option>
            <option value="zorg" :selected="hasOrganization('zorg')">Zorgbedrijf</option>
            <option value="maak" :selected="hasOrganization('maak')">Maakbedrijf</option>
            <option value="retail" :selected="hasOrganization('retail')">Retail</option>
            <option
              value="consultancy"
              :selected="hasOrganization('consultancy')"
            >Freelance &amp; consultancy</option>
            <option value="other" :selected="hasOrganization('other')">Andere</option>
    </select>-->
  </div>
</template>

 <script>
import CompanyTypesMixins from "../mixins/CompanyTypes.js";
export default {
  mixins: [CompanyTypesMixins],
  props: ["value"],
  computed: {
    selected() {
      return this.value;
    },
    hasOrganization() {
      return item => this.selected.includes(item);
    }
  },
  methods: {
    toggleOrganization(e) {
      const value = e.target.value;

      if (value === "algemeen") {
        return;
      }

      const index = this.selected.indexOf(value);
      if (index !== -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(value);
      }

      this.$emit("input", this.selected);
    }
  }
};
</script>

<style scoped>
label {
  display: block;
}
</style>
